/*************************************************************************
 * 
 * KLEARNOW CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import React, { Component } from 'react'
import { Checkbox } from 'semantic-ui-react'

export default class CustomCheckbox extends Component {
  
  constructor(props) {
    super(props);
     this.state = {
      showconfirmationBox: false
     }
    }

  render() {
    let { label, value, onChange, update, disabled, className, errors, areyousureConfirmationDialogue } = this.props
    let labelClass = className || ''
    labelClass += ' customCheckBox'
    if(errors && errors.length){
      labelClass += ' undone-pga';

    }
    return (
      <>{ this.state.showconfirmationBox
          ? <React.Fragment>
            <button className="ui button"
              onClick={() => {
                this.setState({ showconfirmationBox: false })
              }}
            >CANCEL</button>
            <button className="ui button"

              onClick={() => {
                update && update(!value);
                this.setState({ showconfirmationBox: false })
              }}
            >YES</button>
            Are you sure?
          </React.Fragment>
          :
          <Checkbox
            className={labelClass}
            label={label}
            onChange={() => {
              if (areyousureConfirmationDialogue) {
                this.setState({ showconfirmationBox: true })
              } else {
                update && update(!value);
              }
            }}
            checked={Boolean(value)}
            disabled={disabled}
          />
      }</>
    )
  }
}
